<div fullscreen="true">
  <ion-icon name="warning"></ion-icon>
  <p>{{text}}</p>
</div>